import React from "react";

function Share() {
  return (
    <div class="share">
      <div class="icon">
        <a href="https://github.com/skcyber00">
          <span class="iconify" data-icon="codicon:github-alt"></span>
        </a>
      </div>
      <div class="icon">
        <a href="https://fr.linkedin.com/in/florian-pons-3b4706206?trk=people-guest_people_search-card">
          <span class="iconify" data-icon="akar-icons:linkedin-fill"></span>
        </a>
      </div>
      <div class="position-ligne-vertical">
        <span class="ligne-vertical"></span>
      </div>
    </div>
  );
}

export default Share;
